import React, { useContext, useEffect, useRef } from 'react';
import '../Home/home.scss';
import Social from './Social';
import righthand from '../images/righthand.png';
import lifthand from '../images/lifthand.png';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
import { DataContext } from '../contextAPI';

const Home = () => {
	const { isIntersecting, setIsIntersecting, toggleMode, setToggleMode } =
		useContext(DataContext);

	const ref = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsIntersecting(entry.isIntersecting);
			},
			{ rootMargin: '-300px' }
		);
		console.log(isIntersecting);
		observer.observe(ref.current);

		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		if (isIntersecting) {
			ref.current.querySelectorAll('div').forEach((el) => {
				el.classList.add('slide-in');
			});
		} else {
			ref.current.querySelectorAll('div').forEach((el) => {
				el.classList.remove('slide-in');
			});
		}
	}, [isIntersecting]);

	return (
		<div
			className={`${toggleMode ? 'theme' : 'dark-mode'}`}
			id="Home">
			<div
				className="overall-container"
				ref={ref}>
				<div className="span_1_of_2">
					<div className="font-size">
						<div className="font-gradient hello">Hello There !</div>

						<div className="my-name">I'm Reham Al-khamiasi</div>
						<div className="font-gradient header">Frontend Developer</div>
						<div className="font-gradient header ">& UI /UX Designer</div>
						<AnimatedOnScroll
							animationIn="bounce"
							duration="1000">
							<p className="intro">
								Passionate about crafting immersive digital experiences, I
								specialize in frontend development and UI/UX design. As a
								full-stack developer with a keen eye for detail, I thrive on
								translating complex ideas into intuitive and visually
								captivating interfaces. With a foundation in coding and a
								dedication to user-centric design principles, I create seamless,
								engaging experiences that resonate with audiences. I'm driven by
								the art of merging technology with creativity to build
								compelling solutions that leave a lasting impact.
							</p>
						</AnimatedOnScroll>
						<div className="button-space">
							<button className="shadow__btn">Hire Me</button>
						</div>
					</div>
				</div>

				<div className=" span_1_of_2 ">
					<div style={{ display: 'flex' }}>
						<img
							className="digital-image"
							src={righthand}
							alt="Girl in a jacket"
							width="50%"></img>
						<img
							className="digital-image"
							src={lifthand}
							alt="Girl in a jacket"
							width="50%"></img>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
